import React, { useEffect, useRef } from 'react';
import { Icon } from './components';

export default function WorkspaceTabs({ tabs, activeId, listLabel, onSelect, onClose }) {
  const bar = useRef(null);
  useEffect(() => {
    const selected = bar.current?.querySelector('[aria-selected="true"]');
    selected?.focus({ preventScroll: true });
    selected?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  }, [activeId, tabs.length]);
  function navigate(event) {
    if (event.target.getAttribute('role') !== 'tab') return;
    const buttons = [...bar.current.querySelectorAll('[role="tab"]')];
    const index = buttons.indexOf(event.target);
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
    else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else return;
    event.preventDefault(); buttons[next].focus(); buttons[next].click();
  }
  return <div ref={bar} className="ex-workspace-tabs" role="tablist" aria-label="Vues et dossiers ouverts" onKeyDown={navigate}>
    {[{ id: '', label: listLabel }, ...tabs].map(tab => <div key={tab.id} role="presentation" className={`ex-workspace-tab ${activeId === tab.id ? 'is-active' : ''}`}>
      <button type="button" role="tab" id={`ex-tab-${tab.id || 'list'}`} aria-controls={`ex-panel-${tab.id || 'list'}`} aria-selected={activeId === tab.id} tabIndex={activeId === tab.id ? 0 : -1} onClick={() => onSelect(tab.id)} title={tab.label}>
        <Icon name={tab.id ? 'contact' : 'folder'} size={18} /><span>{tab.label}</span>
      </button>
      {tab.id && <button type="button" className="ex-tab-close" aria-label={`Fermer l’onglet ${tab.label}`} onClick={() => onClose(tab.id)}><Icon name="close" size={17} /></button>}
    </div>)}
  </div>;
}
